import { Link } from "react-router-dom";
import ContactForm from "@/components/ContactForm";
import { useScrollAnimation } from "@/hooks/use-scroll-animation";
import { cn } from "@/lib/utils";

const NewFinalCTA = () => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1 });

  return (
    <section 
      id="contacto" 
      ref={ref as React.RefObject<HTMLElement>}
      className="py-14 md:py-20 bg-tera-dark relative overflow-hidden"
    >
      {/* Decorative elements */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/10 rounded-full blur-[100px]" />
      <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-secondary/10 rounded-full blur-[80px]" />

      <div className="container px-4 sm:px-6 relative z-10 w-full max-w-full overflow-hidden">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center max-w-6xl mx-auto">
          {/* Content */}
          <div className={cn(
            "text-center lg:text-left transition-all duration-700 break-words",
            isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"
          )}>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-primary-foreground mb-4 sm:mb-6 leading-tight">
              ¿Listo para proteger tu empresa y controlar tu operación{" "}
              <span className="text-gradient-gold">sin sorpresas?</span>
            </h2>
            
            <p className="text-base sm:text-lg text-primary-foreground/80 mb-6 sm:mb-8 leading-relaxed break-words">
              Cuéntanos qué necesitas y te enviamos una propuesta clara, diseñada a tu medida y sin letra pequeña.
            </p>

            <div className="hidden lg:flex items-center gap-6">
              <div className="flex -space-x-3">
                {[...Array(4)].map((_, i) => (
                  <div
                    key={i}
                    className="w-10 h-10 rounded-full bg-primary/20 border-2 border-tera-dark flex items-center justify-center"
                  >
                    <span className="text-primary-foreground text-xs font-medium">
                      {["M", "O", "S", "I"][i]}
                    </span>
                  </div>
                ))}
              </div>
              <div className="text-left">
                <p className="text-primary-foreground font-medium">+70 empresas confían en nosotros</p>
                <p className="text-primary-foreground/60 text-sm">4.9/5 en Google</p>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className={cn(
            "bg-card p-5 sm:p-8 rounded-2xl shadow-lg border border-border/20 transition-all duration-700 delay-200 min-w-0 overflow-hidden",
            isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"
          )}>
            <h3 className="text-lg sm:text-xl font-semibold text-foreground mb-5 sm:mb-6 text-center">
              Solicita tu evaluación sin costo
            </h3>
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewFinalCTA;
